import React, { useState } from "react";
import { FaChevronDown, FaChevronUp } from "react-icons/fa";
import { useLanguage } from "../Translations/LenguageContext";

const Models = () => {
    const { t } = useLanguage();
    const [openFamily, setOpenFamily] = useState(null);

    const modelFamilies = t.availableModels.listData; // translation-driven model data

    const toggleFamily = (familyName) => {
        openFamily === familyName ? setOpenFamily(null) : setOpenFamily(familyName);
    };

    const familyLogos = {
        Qwen: "/logos/qwen.svg",
        Llama: "/logos/meta.svg",
        "GPT-OSS": "/logos/gpt.svg",
        DeepSeek: "/logos/deepseek.svg",
        Mistral: "/logos/mistral.svg",
        Phi: "/logos/microsoft.svg"
    }

    return (
        <div className="models_cont fade-in">
            <h3>{t.availableModels.title}</h3>

            <div className="models_card_cont">
                {Object.entries(modelFamilies).map(([familyName, models]) => (
                    <div className="models_card_family" key={familyName}>
                        <div
                            className="model_fam_header"
                            onClick={() => toggleFamily(familyName)}
                            style={{ cursor: "pointer" }}
                        >
                            <img
                                src={familyLogos[familyName]}
                                alt={`${familyName} logo`}
                                className="model_fam_logo"
                            />
                            <p className="model_fam_title">{familyName}</p>
                            <span style={{ marginLeft: "auto" }}>
                                {openFamily === familyName ? <FaChevronUp /> : <FaChevronDown />}
                            </span>
                        </div>

                        <div className={`models_list ${openFamily === familyName ? "models_list_open" : ""}`}>
                            {models.map((model, i) => (
                                <div className="model_card" key={i}>
                                    <div className="model_type">{model.name}</div>
                                    <div className="model_purpose_cont">
                                        {model.categories.map((p, j) => (
                                            <span className="model_purpose" key={j}>{p}</span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

            <h4 style={{ color: "gray", fontSize: "14px" }}>{t.availableModels.moreSoon}</h4>
        </div>
    );
};

export default Models;
